import { Injectable } from '@angular/core';
import { Observable, interval } from 'rxjs';
import { exhaustMap, first, timeout } from 'rxjs/internal/operators';


export interface PollOptions {
  interval: number;
  timeout: number;
}

const OPTIONS_DEFAULT: PollOptions = {
  interval: 5000,
  timeout: 90000
};

@Injectable({ providedIn: 'root' })
export class HelperService {

  // constructor() { }

  startPoll<T>(
    pollFn: () => Observable<T>, // intermediate polled responses
    stopPollPredicate: (value: T) => boolean, // condition to stop polling
    options: PollOptions = OPTIONS_DEFAULT): Observable<T> {
    return interval(options.interval)
      .pipe(
        exhaustMap(() => pollFn()),
        first(value => stopPollPredicate(value)),
        timeout(options.timeout)
      );
  }

}
